import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getPackagesAction } from '../../../services/request';
import { PackageList } from './package/PackageList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

export const PackageRecord = () => {
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(getPackagesAction(search, 'GET'));
  const optionsRequest = useQuery(getPackagesAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [periods, setPeriods] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [choices, setChoices] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setPeriods(payload.results);
    }
  }, [loading]);

  React.useEffect(() => {
    if (!optionsRequest.loading && !optionsRequest.error) {
      setChoices(optionsRequest.payload.actions.GET.choices);
    }
  }, [optionsRequest.loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setPeriods(
        _.map(periods, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setPeriods(_.filter(periods, obj => obj.id !== obj2.id));
    } else {
      setPeriods([obj2, ...periods]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Box display="flex" justifyContent="center">
      </Box>
      <PackageList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        periods={periods}
        queryCallback={queryCallback}
        submitCallback={submitCallback}
        choices={choices}
      />
    </>
  );
};
